// Importing Swiper and its modules
import Swiper from "swiper/bundle";
import noUiSlider from "nouislider";
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import Flickity from "flickity";
import Scrollbar from "smooth-scrollbar";
import Splide from "@splidejs/splide";
import * as Sentry from "@sentry/browser";
import focus from "@alpinejs/focus";

Alpine.plugin(collapse);
Alpine.plugin(focus);

require("flatpickr");
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.Flickity = Flickity;
window.Alpine = Alpine;
window.Scrollbar = Scrollbar;
window.Splide = Splide;

window.toast = function(message, options = {}) {
  let description = "";
  let type = "default";
  let position = "top-center";
  let html = "";
  if (typeof options.description != "undefined") description = options.description;
  if (typeof options.type != "undefined") type = options.type;
  if (typeof options.position != "undefined") position = options.position;
  if (typeof options.html != "undefined") html = options.html;

  window.dispatchEvent(new CustomEvent("toast-show", {
    detail: {
      type: type, message: message, description: description, position: position, html: html
    }
  }));
};

function popToast(object, custom) {
  let html = "";
  if (typeof custom != "undefined") {
    html = custom;
  }
  toast(object.title, { description: object.description, type: object.type, position: object.position, html: html });
}

function magnifierSetup() {
  return {
    showMagnifier: false, currentImage: "", bgSize: 600, // Zoom level
    bgPos: "0% 0%", cursorX: 0, cursorY: 0, widthImage: 200, heightImage: 200,

    handleMouseMove(event, imageUrl) {
      const isMobile = window.innerWidth < 768; // Adjust this threshold as needed

      if (isMobile) {
        this.widthImage = 120;
        this.heightImage = 120;
        this.bgSize = 800;
      }
      this.showMagnifier = true;
      this.currentImage = imageUrl;
      console.log(this.currentImage);
      const imgRect = event.target.getBoundingClientRect();
      const x = event.clientX - imgRect.left;
      const y = event.clientY - imgRect.top;

      // Update background position for zoom effect
      this.bgPos = `${(x / imgRect.width) * 100}% ${(y / imgRect.height) * 100}%`;

      // Adjust these values based on your design and device type
      const offsetX = isMobile ? -40 : 20;// Closer to the cursor on mobile
      const offsetY = isMobile ? -160 : -220; // Less offset on mobile

      // Update cursor position with offset
      this.cursorX = event.clientX + offsetX - imgRect.left;
      this.cursorY = event.clientY + offsetY - imgRect.top;
    },

    handleTouchMove(event, imageUrl) {
      if (event.touches.length > 0) {
        this.handleMouseMove(event.touches[0], imageUrl);
      }
    },

    hideMagnifier() {
      this.showMagnifier = false;
    }
  };
}


let custom_scrollbar_brand = document.querySelector(".custom-scrollbar-brand");

if (custom_scrollbar_brand) {
  let scrollbar_options_brand = {
    alwaysShowTracks: true
  };
  Scrollbar.init(document.querySelector(".custom-scrollbar-brand"), scrollbar_options_brand);
}

let customScrollbars = document.querySelectorAll(".custom-scrollbar");

if (customScrollbars.length) {
  let scrollbar_options = {
    alwaysShowTracks: true
  };
  for (let i = 0; i < customScrollbars.length; i++) {
    let customScrollbarsElement = customScrollbars[i];
    Scrollbar.init(customScrollbarsElement, scrollbar_options);
  }
}

function splideAssociations() {
  if (document.querySelector(".splide-associations")) {
    const splideAssociations = new Splide(".splide-associations").mount();
    if (window.innerWidth <= 640) {

      splideAssociations.on("moved", function() {
        const currentIndex = splideAssociations.index;
        const totalSlides = splideAssociations.Components.Elements.slides.length;
        const splideContent = document.querySelector(".move-splide-content");
        const trackChildren = splideContent.children;

        if (currentIndex === totalSlides - 2) {
          splideContent.style.marginLeft = "-2.25rem";
          trackChildren[0].style.marginLeft = "2.25rem";
          splideAssociations.options = { padding: { right: "2.25rem", left: "3.5rem" } };
        } else {
          splideContent.style.marginLeft = "0";
          trackChildren[0].style.marginLeft = "0";
          splideAssociations.options = { padding: { right: "3.5rem", left: "0" } };
        }
      });
    }
  }
}

function splideBase() {
  if (document.querySelector(".splide-base")) {
    const splideBase = new Splide(".splide-base").mount();
    if (window.innerWidth <= 640) {
      splideBase.on("moved", function() {
        document.querySelector(".move-splide-content");
      });
    }
  }
}

function visibilityTracker() {
  // Helper to create and manage IntersectionObservers
  function createObserver(ref, callback) {
    if (!ref) {
      console.error(`Element for observer not found`);
      return null;
    }
    const observer = new IntersectionObserver(callback);
    observer.observe(ref);
    return observer;
  }

  return {
    isVisible: false,    // Determines if the floating element should be shown
    atBottom: false,     // Tracks if the bottom sentinel is in view
    holeContentV: false, // Tracks visibility of the "hole content" element
    totalBox: false,     // Tracks visibility of the totalBox element
    _observers: [],      // Store observers for cleanup

    recalcVisibility() {
      this.isVisible = this.holeContentV && !this.totalBox;
    },

    init() {
      this._observers = [
        createObserver(this.$refs.totalBox, (entries) => {
          entries.forEach(entry => {
            this.totalBox = entry.isIntersecting;
            this.recalcVisibility();
          });
        }),
        createObserver(this.$refs.bottomSentinel, (entries) => {
          entries.forEach(entry => {
            this.atBottom = entry.isIntersecting;
          });
        }),
        createObserver(this.$refs.holeContent, (entries) => {
          entries.forEach(entry => {
            this.holeContentV = entry.isIntersecting;
            this.recalcVisibility();
          });
        })
      ].filter(Boolean);
    },

    destroy() {
      this._observers.forEach(observer => observer.disconnect());
      this._observers = [];
    }
  };
}

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
  sendDefaultPii: true,
  ignoreErrors: [
    /window\.webkit\.messageHandlers/,
    /Java object is gone/,
    /enableButtonsClickedMetaDataLogging/,
  ],
  denyUrls: [
    /iabjs:\/\//,
  ],
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
      networkRequestHeaders: ["Cache-Control"],
      networkResponseHeaders: ["Referrer-Policy"]
    }),
    Sentry.browserTracingIntegration(),
    Sentry.replayCanvasIntegration(),
    Sentry.browserProfilingIntegration()
  ],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: process.env.MIX_SENTRY_PROFILES_SAMPLE_RATE,
  tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE
});

window.dataLayer = window.dataLayer || [];

function gtag() {
  dataLayer.push(arguments);
}

gtag("consent", "default", {
  "ad_storage": "denied",
  "analytics_storage": "denied",
  "functionality_storage": "denied",
  "personalization_storage": "denied",
  "security_storage": "denied",
  "ad_user_data": "denied",
  "ad_personalization": "denied",
  "wait_for_update": 2000
});

function sendConsentToGTM(consent) {
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  gtag("consent", "update", {
    "ad_storage": consent.ad_storage,
    "analytics_storage": consent.analytics_storage,
    "functionality_storage": consent.functionality_storage,
    "personalization_storage": consent.personalization_storage,
    "security_storage": consent.security_storage,
    "ad_user_data": consent.ad_user_data,
    "ad_personalization": consent.ad_personalization
  });
}

function loadGoogleAnalytics() {
  sendConsentToGTM({
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted"
  });
}

window.splideAssociations = splideAssociations;
window.splideBase = splideBase;
window.popToast = popToast;
window.magnifierSetup = magnifierSetup;
window.visibilityTracker = visibilityTracker;
window.sendConsentToGTM = sendConsentToGTM;
window.loadGoogleAnalytics = loadGoogleAnalytics;
window.Sentry = Sentry;
window.Alpine.start();